import "./corporate-search.scss"

const hiddenClass = "d-none"
const attentionClass = "is-attention"

// 各種ハイフン・長音記号。KatakanaAddressValidator と同じ文字集合を「ー」に寄せる。
const HYPHEN_PATTERN = /[-﹣－‐‑⁃˗−⧿‒–—―⸺⸻﹘─━╴╶╸╺⎯⏤➖᠆᠊ｰ]/g
const TRIM_PATTERN = /^\s+|\s+$/g   // JS の \s は NBSP(U+00A0) を含む

// 前後の空白差まで同一とみなして比較する項目 (IH-1310)
// 法人名（カナ）は「一致＝法人格の入力漏れの疑い」として色付けするため、
// 末尾の空白ごときで「不一致＝正常」と誤判定しないよう空白差を吸収する。
// 逆にそれ以外の項目は ✓/✗ を表示するだけであり、かつ法人名・郵便番号・都道府県は
// 改修①のトリム対象外（末尾空白が保存されたまま残る）ため、
// 空白差は「気づくべき差分」として ✗ のまま見せる。
const TRIM_COMPARE_KEYS = ["nameKana"]

// 比較用の正規化 (IH-1310)
// NFKC で「半角カナ→全角カナ」「全角英数→半角」「全角スペース→半角スペース」を吸収し、
// ハイフン・長音記号を統一する。中間の空白は常に残す。
const normalize = (value, trimEnds = false) => {
  const normalized = (value || "")
    .normalize("NFKC")
    .replace(HYPHEN_PATTERN, "ー")
  return trimEnds ? normalized.replace(TRIM_PATTERN, "") : normalized
}

const container = {
  corporateNumber: { element: null, input: "", search: "" },
  name: { element: null, input: "", search: "" },
  nameKana: { element: null, input: "", search: "" },
  postCode: { element: null, input: "", search: "" },
  prefecture: { element: null, input: "", search: "" },
  city: { element: null, input: "", search: "" },
  street: { element: null, input: "", search: "" },
}

const fetchCorporateData = async (corporateNumber) => {
  const response = await fetch(`/api/v1/corporates/${corporateNumber}`).catch(e => { throw e })
  if (! response.ok) throw new Error("API request failed.")
  const data = await response.json()
  return data
}

const resetSearchResults = () => {
  Object.keys(container).forEach(key => { container[key].search = "" })
}

const getDifferences = () => {
  const differences = []
  Object.keys(container).forEach(key => {
    const trimEnds = TRIM_COMPARE_KEYS.includes(key)
    if (normalize(container[key].input, trimEnds) !== normalize(container[key].search, trimEnds)) {
      differences.push(key)
    }
  })
  return differences
}

const activate = (elements) => {
  setInputElements(elements)
  setSearchHandler()

  container.corporateNumber.element.dispatchEvent(new Event("input"))
}

const setInputElements = (elements) => {
  Object.keys(elements).forEach(key => {
    container[key].input = elements[key].value
    container[key].element = elements[key]
    container[key].element.addEventListener("input", (event) => {
      container[key].input = event.target.value
      updateView()
    })
  })
}

const setSearchHandler = async () => {
  container.corporateNumber.element.addEventListener("input", async (event) => {
    if (! container.corporateNumber.input.match(/^\d{13}$/)) {
      resetSearchResults()
      updateView()
      return
    }

    try {
      const data = await fetchCorporateData(container.corporateNumber.input)
      container.corporateNumber.search = data.corporate_number
      container.name.search = data.name
      container.nameKana.search = data.furigana
      container.postCode.search = data.post_code
      container.prefecture.search = data.prefecture_name
      container.city.search = data.city_name
      container.street.search = data.street_number
    } catch (_) {
      resetSearchResults()
    }

    updateView()
  })
}

const copyResultValuesToInput = () => {
  if (! container.corporateNumber.search) return

  Object.keys(container).forEach(key => {
    container[key].input = container[key].search
    container[key].element.value = container[key].search
  })
  updateView()
}

const updateView = () => {
  const differences = getDifferences()
  document.querySelectorAll(".result-container").forEach(element => {
    element.querySelectorAll(".material-icons").forEach(icon => { icon.classList.remove(hiddenClass) })
    const dataKey = element.dataset.key
    element.querySelector(differences.includes(dataKey) ? ".icon-ok" : ".icon-ng").classList.add(hiddenClass)

    element.querySelector(".result-content").innerHTML = container[dataKey].search
  })

  updateNameKanaAttention(differences)
}

// 法人名（カナ）は法人格（カブシキガイシャ 等）を手入力する運用のため、
// 法人番号APIの結果と一致している＝法人格の入力漏れの疑いがある。(IH-1310)
// 検索結果を取得できていないとき（法人番号が未入力・13桁でない・API失敗）は判定しない。
const updateNameKanaAttention = (differences) => {
  const element = container.nameKana.element
  if (! element) return

  const isMatched = !! container.nameKana.search && ! differences.includes("nameKana")
  element.classList.toggle(attentionClass, isMatched)
}

export default {
  activate,
  copyResultValuesToInput,
}
